import { Component, createRef } from "react"

/* Components */
import { DataLayout, Pagination, Icon, Avatar } from "../../components"

/* Widgets */
import { DetailsModal, FilterModal, INITIAL_FILTER, filterCount, periodTitle } from "../../widgets/booking"

/* Shared */
import { CHANNELS, bookingIcon, number, priceOf, statusOf } from "../../widgets/booking/shared"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* Constants */
import { env } from "../../constants"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* REST API */
import { list } from "../../api/Booking"

moment.locale("ru")


/* Page Bookings — the visits of the whole platform. The page opens on the current month
   and everything else is chosen in the window of the filters */
class Bookings extends Component {

    constructor() {
        super()

        this.state = {

            data: [],
            status: "loading",
            count: 0,
            page: 1,
            statistics: null,
            search: "",
            filter: { ...INITIAL_FILTER }
        }

        /* The card of the visit and the filters are opened by the reference */
        this._details = createRef()
        this._filter = createRef()
    }

    componentDidMount = () => {

        window.scrollTo(0, 0)
        this.load()
    }

    /* Load action */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { search, filter } = this.state

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        this.setState({ page })

        /* Set to REST API */
        list({
            page,
            search,
            organizationID: filter.organizationID,
            status: filter.status,
            channel: filter.channel,
            startDate: moment(filter.startDate).format("YYYY-MM-DD"),
            endDate: moment(filter.endDate).format("YYYY-MM-DD")
        }).then(response => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count, statistics: response.data.statistics })
            }
            else {
                this.setState({ status: "error", data: [], count: 0, statistics: null })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0, statistics: null })
        })
    }

    /* On Submit */
    search = event => {
        event.preventDefault()
        this.load(1)
    }

    /* Search Action */
    searchText = text => {
        if (text === "") {
            this.setState({ search: text }, () => this.load(1))
        }
        else {
            this.setState({ search: text })
        }
    }

    /* Open the card of the visit */
    open = item => {
        this._details.current.open(item)
    }

    /* Draw one visit of the table */
    _item = (item, index) => {

        const image = item.organizationImage ? `${env.mediapoint}organizations/${item.organizationImage}` : null
        const state = statusOf(item.status)
        const channel = utils.check(CHANNELS[item.channel], item.channel)

        return (
            <div onClick={() => this.open(item)} className="booking-item" key={`${index}`}>

                <div className="booking-item-cell client">

                    <Avatar className="booking-item-avatar" src={image} alt={item.organization}>
                        {bookingIcon()}
                    </Avatar>

                    <div className="booking-item-title">
                        <div className="booking-item-name">
                            {utils.check(item.user, "Без имени")}
                            <div className="booking-item-badge">№{utils.check(item.number, item.id)}</div>
                        </div>
                        <div className="booking-item-text">{utils.check(item.phone, "—")}</div>
                    </div>

                </div>

                <div className="booking-item-cell organization">
                    <div className="booking-item-value">{utils.check(item.organization, "Организация удалена")}</div>
                    <div className="booking-item-text">{utils.check(item.member, "Мастер не указан")}</div>
                </div>

                <div className="booking-item-cell time">
                    <div className="booking-item-value">{moment(item.reservedTime).format("DD.MM.YYYY")}</div>
                    <div className="booking-item-text">{moment(item.reservedTime).format("HH:mm")} · {utils.check(item.sessionTime, "—")} мин</div>
                </div>

                <div className="booking-item-cell service">
                    <div className="booking-item-value">{utils.check(item.service, "Услуга не указана")}</div>
                    <div className="booking-item-text">{channel}</div>
                </div>

                <div className="booking-item-cell total">
                    <div className="booking-item-price">{utils.convertor(priceOf(item), "₸", 1)}</div>
                    {item.finalPrice !== null && item.finalPrice !== undefined && <div className="booking-item-text">оплачено</div>}
                </div>

                <div className="booking-item-cell state">
                    <div className={`booking-item-state ${state.accent}`}>
                        <i />
                        {state.text}
                    </div>
                </div>

                <div className="booking-item-cell arrow">
                    <Icon name="right" size={15} width={2} />
                </div>

            </div>
        )
    }

    /* The numbers of the chosen period — one slim line over the table */
    _summary = () => {

        /* Fields */
        const { statistics, filter } = this.state

        /* Check Data */
        if (!statistics) {
            return null
        }

        return (
            <div className="booking-summary">

                <div className="booking-summary-period">
                    <span>Период</span>
                    {periodTitle(filter)}
                </div>

                <div className="booking-summary-values">
                    <div className="booking-summary-value">Всего <b>{number(statistics.total)}</b></div>
                    <div className="booking-summary-value">Завершены <b className="green">{number(statistics.completed)}</b></div>
                    <div className="booking-summary-value">Ожидание <b className="orange">{number(statistics.waiting)}</b></div>
                    <div className="booking-summary-value">Отменены <b className="red">{number(statistics.cancelled) + number(statistics.missed)}</b></div>
                    <div className="booking-summary-value">Выручка <b className="blue">{utils.convertor(Math.round(number(statistics.revenue)), "₸", 1)}</b></div>
                </div>

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Layout */
        if (status !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    {status === "ok" && this._summary()}
                    <DataLayout status={status} reload={() => this.load(1, true)} data={data} onReset={() => this.setState({ search: "", filter: { ...INITIAL_FILTER } }, () => this.load(1, true))} />
                </div>
            )
        }

        return (
            <div className="page-content">

                {this._summary()}

                <div className="booking-list">

                    <div className="booking-item head">
                        <div className="booking-item-cell client">Клиент</div>
                        <div className="booking-item-cell organization">Организация</div>
                        <div className="booking-item-cell time">Время</div>
                        <div className="booking-item-cell service">Услуга</div>
                        <div className="booking-item-cell total">Сумма</div>
                        <div className="booking-item-cell state">Статус</div>
                        <div className="booking-item-cell arrow" />
                    </div>

                    {data.map((item, index) => this._item(item, index))}

                </div>

                <Pagination size={20} page={page} total={count} onPageChange={page => this.load(page, true)} />

            </div>
        )
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const { search, filter } = this.state

        const active = filterCount(filter)

        return (
            <div className="booking-header">

                <div className="page-header-text">Записи</div>

                <div className="booking-header-tools">

                    <form onSubmit={this.search} className="booking-search">

                        <div className="booking-search-icon">
                            <Icon name="search" size={17} />
                        </div>

                        <input placeholder="Номер, имя, телефон, организация" value={search} onChange={event => this.searchText(event.target.value)} />

                        {search.length > 0 &&
                            <div onClick={() => this.searchText("")} className="booking-search-clear">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        }

                    </form>

                    <div onClick={() => this._filter.current.open(filter)} title="Фильтр" className={`booking-filter-button ${active > 0 ? "active" : ""}`}>
                        <Icon name="filter" size={19} />
                        {active > 0 && <div className="booking-filter-count">{active}</div>}
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        return (
            <div className="page">

                {/* Draw Header */}
                {this._header()}

                {/* Draw Content */}
                {this._content()}

                {/* Draw Details */}
                <DetailsModal ref={this._details} onChanged={() => this.load(this.state.page)} />

                {/* Draw Filters */}
                <FilterModal ref={this._filter} onApply={filter => this.setState({ filter }, () => this.load(1, true))} />

            </div>
        )
    }
}

export default withRouter(Bookings)
